import React from 'react'
import { Link } from 'react-router-dom'
import { Panel, Grid, Col, Row } from 'react-bootstrap'

const SAPResourceCard = props => {
    const { resource } = props

    let postedDate = resource.created_date.split("T")[0].split("-")
    let formatedDate = `${postedDate[1]}-${postedDate[2]}-${postedDate[0]}`

    const formattedAuthors = Array.isArray(resource.authors) ?
        resource.authors.map(author => `${author.first_name} ${author.last_name}`).join(', ')
        :
        'N/A'

    const formattedExternalClient = resource.external_client ?
        `${resource.external_client.name} ${resource.external_client.short_code}`
        :
        'N/A'

    let sapOrProtocol = 'N/A'
    if (resource.is_protocol && resource.is_sap) {
        sapOrProtocol = 'Both'
    } else if (resource.is_protocol) {
        sapOrProtocol = 'Protocol'
    } else if (resource.is_sap) {
        sapOrProtocol = 'SAP'
    }

    return (
        <Col xs={12} md={12}>
            <div id="PostCard">
                <Panel>
                    <Panel.Heading className="post-card-heading">
                    </Panel.Heading>
                    <Panel.Body className="post-card-body">
                        <Grid>
                            <Link to={`/sap-repository/${resource.id}`}>
                                <Row className="clickable-row">
                                    <Col xs={12} md={7}>
                                        <h3 className="post-description">
                                            {resource.title}
                                        </h3>
                                        <br />
                                    </Col>
                                    <Col xs={12} md={5}>
                                        <div>
                                            <span style={{fontWeight: 'bold'}}>
                                                Posted on: 
                                            </span> {' '}
                                            {formatedDate}
                                        </div>
                                        <div>
                                            <span style={{fontWeight: 'bold'}}>
                                                Authors:
                                            </span> {' '}
                                            {formattedAuthors}
                                        </div>
                                        <div>
                                            <span style={{fontWeight: 'bold'}}>
                                                External Client:
                                            </span> {' '}
                                            {formattedExternalClient}
                                        </div>
                                        <div>
                                            <span style={{fontWeight: 'bold'}}>
                                                SAP or Protocol:
                                            </span> {' '}
                                            {sapOrProtocol}
                                        </div>
                                    </Col>
                                </Row>
                            </Link>
                        </Grid>
                    </Panel.Body>
                </Panel>
            </div>
        </Col>
    )
}

export default SAPResourceCard



// WEBPACK FOOTER //
// ./src/routes/sap-resources/components/SAPResourceCard.js